import { render, staticRenderFns } from "./BackupsPage.vue?vue&type=template&id=5a84f13a&lang=pug"
import script from "./BackupsPage.vue?vue&type=script&lang=js"
export * from "./BackupsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports